var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDecent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94.189,
    height: 88.648,
    viewBox: "0 0 94.189 88.648",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "decent",
    transform: "translate(-3.5 -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_821",
    "data-name": "Path 821",
    d: "M22.041,15.581a5.541,5.541,0,1,0,5.541-5.541A5.54,5.54,0,0,0,22.041,15.581Zm5.541,11.081A11.081,11.081,0,1,1,38.662,15.581,11.081,11.081,0,0,1,27.581,26.662Z",
    transform: "translate(59.027)",
    fill: "#fd792f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_822",
    "data-name": "Path 822",
    d: "M3.5,18.351A13.857,13.857,0,0,0,23.292,30.868a2.775,2.775,0,0,0,.411.524L33.95,41.638A19.4,19.4,0,0,0,56.7,70l1.465,2.93a11.083,11.083,0,1,0,6.278-1.949q-.523,0-1.034.048l-1.755-3.51a19.4,19.4,0,0,0,4.452-27.565,2.852,2.852,0,0,0,.3-.257l8.311-8.311A2.77,2.77,0,1,0,70.8,27.473l-8.311,8.311a2.851,2.851,0,0,0-.257.3A19.4,19.4,0,0,0,37.468,37.32L27.7,27.555a13.851,13.851,0,1,0-24.2-9.2Zm13.851,8.311a8.311,8.311,0,1,1,8.311-8.311A8.311,8.311,0,0,1,17.351,26.662ZM64.446,87.608a5.541,5.541,0,1,1,5.541-5.541A5.54,5.54,0,0,1,64.446,87.608ZM50.594,65.446A13.851,13.851,0,1,1,64.446,51.594,13.851,13.851,0,0,1,50.594,65.446Z",
    fill: "#fd792f",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecent);
export default __webpack_public_path__ + "static/media/decent.926f59f2f9473348b9c3ebeeef324763.svg";
export { ForwardRef as ReactComponent };